<mailgun-html #htmlContents [html]="data.content | mailgunMarkAsHtml" />
<email-margin [height]="12" />
<hr />
<email-margin [height]="12" />
<table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
  <tr>
    <td align="left" valign="middle" style="vertical-align: middle; text-align: left">
      <email-text [contents]="data.footer.prefix" color="light" presetName="inline" size="small" />

      <div style="height: 18px; display: inline-block; vertical-align: middle">
        <img
          class="logo"
          [src]="'assets/logo-recruitee-footer.png'"
          alt="Recruitee"
          [width]="67"
          [height]="18"
          style="display: block; vertical-align: middle"
        />
      </div>

      <email-text
        [contents]="data.footer.suffix"
        color="light"
        presetName="inline"
        size="small"
      />&nbsp;
    </td>
  </tr>
</table>
